import { AppBar, Box, Button, CircularProgress, Dialog, Divider, IconButton, InputAdornment, MenuItem, Paper, Popover, Slide, TextField, Toolbar, Tooltip, Typography } from '@material-ui/core';
import React, { Component } from 'react'
import { getDataIsdeletedFalse, getPrimaryColor, getSecondaryColor } from '../../Helper/CommonThings';
import Service from '../../../config/networkutils';
import { getCookie } from '../../../utils/CookieHelper';
import { withSnackbar } from 'notistack';
import CloseIcon from '@material-ui/icons/Close';
import Secured from '../../Secured/Secured';
import UnsecuredProjects from '../../UnsecuredProjects/UnsecuredProjects';
import ProjectList from './ProjectList';
import SearchIcon from '@material-ui/icons/Search';
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state';
import { Grid, Link, ToggleButton, ToggleButtonGroup } from '@mui/material';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import GetAppIcon from '@material-ui/icons/GetApp';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CompletedProjectsList from '../CompletedProjects/CompletedProjectsList';

const token = getCookie("ptd_ts_token");

const secured_api = '/api/crm/user/pref/crm_user_favourite_project/?stage=5&is_trashed=False&key=secured'
const unsecured_api = '/api/crm/user/pref/crm_user_favourite_project/?stage=3&is_trashed=False&key=unsecured'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

class Projects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: 0,
            projectTab: 0,
            liveSecured: [],
            completed: [],
            liveSecuredCopy: [],
            completedCopy: [],
            liveUnsecured: [],
            liveUnsecuredCopy: [],
            isLoading: true,
            open: false,
            selectedOppurtunity: {},
            liveOrCompleted: 0,
            searchCopy: [],
            showSecuredAll: false,
            showUnsecuredAll: false,
            projectCompleteLoadingFlag: true,
            projectType: 0,
            unallocatedToggleView: 0
        }
        this.handlegetData = this.handlegetData.bind(this)
        this.handleShowAll = this.handleShowAll.bind(this)
        this.toggleButtonGroup = React.createRef();
        this.refSearch = React.createRef();
    }

    handleClose = () => {
        this.getSecuredProjects(secured_api)
        this.setState({ open: false })
    }

    handleChangeTab(e, newValue) {
        this.setState({
            tab: newValue,
            isLoading: true
        }, () => {
            if (this.state.tab === 0) {
                this.getSecuredProjects(secured_api)
            } else {
                this.getSecuredProjects(unsecured_api)
            }
        })
    }

    getSecuredProjects(api) {
        Service.get(api, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data.live);
                this.setState({
                    liveSecured: resData,
                    liveSecuredCopy: resData,
                }, () => {
                    this.getUnsecuredProjects(unsecured_api)
                })
            })
            .catch(error => {
                console.log(error)
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    })
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    })
                }
            })
    }

    getUnsecuredProjects(api2) {
        Service.get(api2, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data.live);
                this.setState({
                    liveUnsecured: resData,
                    liveUnsecuredCopy: resData,
                }, () => {
                    if (this.state.projectCompleteLoadingFlag) {
                        this.props.projectCompleteLoading()
                        if (this.refSearch && this.refSearch.current) {
                            this.refSearch.current.getData()
                        }
                        this.setState({
                            isLoading: false,
                            projectCompleteLoadingFlag: false
                        })
                    }
                })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                })
            })
    }

    handleChangeProjectTab(e, newValue) {
        this.setState({
            projectTab: newValue
        })
    }

    screenSizeCheck() {
        if (window.innerWidth > 1600) {
            return true
        } else {
            return false
        }
    }

    componentDidMount() {
        const height = this.divElement.clientHeight;
        const projectHeight = this.projectElement.clientHeight
        this.props.projectHeight(projectHeight)
        if (!this.state.isLoading) {
            this.setState({ height: height }, () => {
                this.props.handleHeight(this.state.height)
            });
        }
        this.getSecuredProjects(secured_api)
    }

    setData(data) {
        let obj = {
            id: data.id,
            contractor_start_date: data.contractor_start_date,
            contractor_end_date: data.contractor_end_date,
            name: data.opportunity_name,
            opportunity_id_id: data.opportunity_id
        }
        this.setState({ selectedOppurtunity: obj }, () => { this.setState({ open: true }) })
    }

    handlegetData() {
        this.setState({
            showSecuredAll: false,
            showUnsecuredAll: false
        }, () => {
            this.getSecuredProjects(secured_api)

        })
    }

    securedSearch(data) {
        const data_lowercase = data.toLowerCase()
        var search_words = data_lowercase.split(" ");
        search_words = search_words.filter(n => n)
        var filtered_data = []
        if (search_words.length === 0) {
            filtered_data = this.state.liveSecuredCopy
        }

        for (let i = 0; i < this.state.liveSecuredCopy.length; i++) {
            const element = this.state.liveSecuredCopy[i];
            var num_of_passed = false
            for (let j = 0; j < search_words.length; j++) {
                const el = search_words[j];
                num_of_passed = element.name.toLowerCase().includes(el)
                if (!num_of_passed) {
                    break
                }
            }
            if (num_of_passed) {
                filtered_data.push(element)
            }
        }
        this.setState({ liveSecured: filtered_data })
        if (data.length > 0) {
            this.setState({
                showSecuredAll: true
            })
        } else {
            this.setState({
                showSecuredAll: false
            })
        }
    }

    unSecuredSearch(data) {
        const data_lowercase = data.toLowerCase()
        var search_words = data_lowercase.split(" ");
        search_words = search_words.filter(n => n)
        var filtered_data = []
        if (search_words.length === 0) {
            filtered_data = this.state.liveUnsecuredCopy
        }

        for (let i = 0; i < this.state.liveUnsecuredCopy.length; i++) {
            const element = this.state.liveUnsecuredCopy[i];
            var num_of_passed = false
            for (let j = 0; j < search_words.length; j++) {
                const el = search_words[j];
                num_of_passed = element.name.toLowerCase().includes(el)
                if (!num_of_passed) {
                    break
                }
            }
            if (num_of_passed) {
                filtered_data.push(element)
            }
        }
        this.setState({ liveUnsecured: filtered_data })
        if (data.length > 0) {
            this.setState({
                showUnsecuredAll: true
            })
        } else {
            this.setState({
                showUnsecuredAll: false
            })
        }
    }

    showAllSecuredData(popupState) {
        this.setState({
            liveSecured: this.state.liveSecuredCopy,
            showSecuredAll: false
        })
        popupState.close()
    }

    showAllUnsecuredData(popupState) {
        this.setState({
            liveUnsecured: this.state.liveUnsecuredCopy,
            showUnsecuredAll: false
        })
        popupState.close()
    }

    handleShowAll() {
        this.setState({
            showSecuredAll: false
        })
    }



    excelExport() {
        let api = '/api/crm/user/pref/crm_user_favourite_project/?is_trashed=False&get_report=true'

        if (this.state.tab === 0) {
            api += '&stage=5'
        } else {
            api += '&stage=3'
        }

        Service.get(api, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.props.enqueueSnackbar('Report will be sent to your email shortly!', {
                    variant: 'success'
                })

            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                })
            })
    }

    showAllCompletedData(popupState) {
        this.setState({
            data: this.state.copyData,
            showCompletedAll: false
        })
        popupState.close()
    }

    completedSearch(data) {
        if (this.refSearch && this.refSearch.current) {
            this.refSearch.current.completedSearch(data)
        }
    }

    render() {

        const handleUnallocatedToggle = (e, newValue) => {
            if (newValue !== null) {
                this.setState({ unallocatedToggleView: newValue }, () => {
                    if (this.toggleButtonGroup && this.toggleButtonGroup.current) {
                        this.toggleButtonGroup.current.changeView(newValue);
                    }
                })
            }
        };


        return (
            <div ref={(divElement) => { this.divElement = divElement }}>
                <Box style={{ border: "2px solid " + getPrimaryColor(), borderRadius: '10px' }}>
                    <Paper style={{ borderRadius: "10px 10px  0 0" }}>
                        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            {this.screenSizeCheck() ?
                                <Grid container spacing={4} >
                                    <Grid item xs={3.8}>
                                        <Box display="flex" justifyContent={'space-between'} alignItems="center">
                                            <Box p={this.screenSizeCheck() ? 2 : 1} style={{ color: getSecondaryColor(), fontSize: this.screenSizeCheck() ? 'medium' : 'small' }}>
                                                <Link component="button" onClick={() => { this.setState({ tab: 0, liveOrCompleted: 0, open: true }) }} style={{ cursor: 'pointer' }} color={getSecondaryColor()}>SECURED</Link>
                                            </Box>
                                            <Box>
                                                <PopupState variant="popover" popupId="demo-popup-popover" >
                                                    {(popupState) => (
                                                        <Box>
                                                            <Box marginTop={0.8}>
                                                                <Tooltip title="Search Secured Projects">
                                                                    <SearchIcon {...bindTrigger(popupState)}
                                                                        fontSize="small" color="secondary" style={{ cursor: 'pointer', marginLeft: "3px", mt: 0.5 }} />
                                                                </Tooltip>
                                                                {this.state.showSecuredAll ?
                                                                    <Button size="small" color='primary' onClick={() => this.showAllSecuredData(popupState)}>Show All</Button> : null}
                                                            </Box>
                                                            <Popover
                                                                {...bindPopover(popupState)}
                                                                anchorOrigin={{
                                                                    vertical: 'bottom',
                                                                    horizontal: 'right',
                                                                }}
                                                                transformOrigin={{
                                                                    vertical: 'top',
                                                                    horizontal: 'left',
                                                                }}>
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', m: 2 }}>
                                                                    <TextField
                                                                        variant='outlined'
                                                                        placeholder='Search'
                                                                        onChange={(event) => this.securedSearch(event.target.value)}
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position='end'>
                                                                                    {this.state.showSecuredAll ?
                                                                                        <IconButton
                                                                                            onClick={() => this.showAllSecuredData(popupState)}
                                                                                        >
                                                                                            <CloseIcon fontSize="small" />
                                                                                        </IconButton> : null}
                                                                                </InputAdornment>
                                                                            )
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Popover>
                                                        </Box>
                                                    )}
                                                </PopupState>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Box display="flex" justifyContent={'space-between'} alignItems="center" >
                                            <Box p={this.screenSizeCheck() ? 2 : 1} style={{ color: getSecondaryColor(), fontSize: this.screenSizeCheck() ? 'medium' : 'small' }}>
                                                <Link component="button" varian onClick={() => { this.setState({ tab: 1, liveOrCompleted: 0, open: true }) }} style={{ cursor: 'pointer' }} color={getSecondaryColor()}>UNSECURED</Link>
                                            </Box>
                                            <Box>
                                                <PopupState variant="popover" popupId="demo-popup-popover" >
                                                    {(popupState) => (
                                                        <Box>
                                                            <Box marginTop={0.8}>
                                                                <Tooltip title="Search Unsecured Projects">
                                                                    <SearchIcon {...bindTrigger(popupState)}
                                                                        fontSize="small" color="secondary" style={{ cursor: 'pointer', marginLeft: "3px", mt: 0.5 }} />
                                                                </Tooltip>
                                                                {this.state.showUnsecuredAll ?
                                                                    <Button size="small" color='primary' onClick={() => this.showAllUnsecuredData(popupState)}>Show All</Button> : null}
                                                            </Box>
                                                            <Popover
                                                                {...bindPopover(popupState)}
                                                                anchorOrigin={{
                                                                    vertical: 'bottom',
                                                                    horizontal: 'right',
                                                                }}
                                                                transformOrigin={{
                                                                    vertical: 'top',
                                                                    horizontal: 'left',
                                                                }}>
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', m: 2 }}>
                                                                    <TextField
                                                                        variant='outlined'
                                                                        placeholder='Search'
                                                                        onChange={(event) => this.unSecuredSearch(event.target.value)}
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position='end'>
                                                                                    {this.state.showUnsecuredAll ?
                                                                                        <IconButton
                                                                                            onClick={() => this.showAllUnsecuredData(popupState)}
                                                                                        >
                                                                                            <CloseIcon fontSize="small" />
                                                                                        </IconButton> : null}
                                                                                </InputAdornment>
                                                                            )
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Popover>
                                                        </Box>
                                                    )}
                                                </PopupState>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Box sx={{ marginTop: '17px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                                            <div style={{ fontSize: this.screenSizeCheck() ? 'medium' : 'small', color: getSecondaryColor() }}  >
                                                COMPLETED
                                            </div>
                                            <Box>
                                                <PopupState variant="popover" popupId="demo-popup-popover" >
                                                    {(popupState) => (
                                                        <Box>
                                                            <Box >
                                                                <Tooltip title="Search Completed Projects">
                                                                    <SearchIcon {...bindTrigger(popupState)}
                                                                        fontSize="small" color="secondary" style={{ cursor: 'pointer', marginLeft: "3px", mt: 0.5 }} />
                                                                </Tooltip>
                                                                {this.state.showCompletedAll ?
                                                                    <Button size="small" color='primary' onClick={() => this.showAllCompletedData(popupState)}>Show All</Button> : null}
                                                            </Box>
                                                            <Popover
                                                                {...bindPopover(popupState)}
                                                                anchorOrigin={{
                                                                    vertical: 'bottom',
                                                                    horizontal: 'right',
                                                                }}
                                                                transformOrigin={{
                                                                    vertical: 'top',
                                                                    horizontal: 'left',
                                                                }}>
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', m: 2 }}>
                                                                    <TextField
                                                                        variant='outlined'
                                                                        placeholder='Search'
                                                                        disabled={this.state.isLoading}
                                                                        onChange={(event) => this.completedSearch(event.target.value)}
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position='end'>
                                                                                    {this.state.showCompletedAll ?
                                                                                        <IconButton
                                                                                            onClick={() => this.showAllCompletedData(popupState)}
                                                                                        >
                                                                                            <CloseIcon fontSize="small" />
                                                                                        </IconButton> : null}
                                                                                </InputAdornment>
                                                                            )
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Popover>
                                                        </Box>
                                                    )}
                                                </PopupState>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid> :
                                <Grid container spacing={4}>
                                    <Grid item xs={6}>
                                        <Box display='flex' flexDirection={'row'} alignItems={'center'} width={'100%'}>
                                            <Box margin={1} display={'flex'} justifyContent={'flex-start'} alignItems={'center'} flexGrow={1}>
                                                <TextField select
                                                    value={this.state.projectType}
                                                    onChange={(event) => this.setState({ projectType: event.target.value })}
                                                    variant='outlined' size='small' label="Project Type" placeholder='Project Type'
                                                >
                                                    <MenuItem value={0}>
                                                        Secured
                                                    </MenuItem>
                                                    <MenuItem value={1}>
                                                        Unsecured
                                                    </MenuItem>
                                                </TextField>
                                            </Box>
                                            <Box>
                                                <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                                                    <Box m={1}>
                                                        <Tooltip title={this.state.projectType === 0 ? "Open Secured Projects" : "Open Unsecured Projects"}>
                                                            <OpenInBrowserIcon fontSize="medium" color="primary" style={{ cursor: 'pointer', marginLeft: "3.5px", marginTop: 2 }} onClick={() => { this.setState({ open: true, tab: this.state.projectType }) }} />
                                                        </Tooltip>
                                                    </Box>
                                                    <PopupState variant="popover" popupId="demo-popup-popover" >
                                                        {(popupState) => (
                                                            <Box>
                                                                <Box m={1}>
                                                                    <Tooltip title={this.state.projectType === 0 ? "Search Secured Projects" : "Search Unsecured Projects"}>
                                                                        <SearchIcon {...bindTrigger(popupState)} fontSize="medium"
                                                                            color="primary" style={{ cursor: 'pointer', marginLeft: "3px" }} />
                                                                    </Tooltip>
                                                                    {this.state.projectType === 0 ?
                                                                        this.state.showSecuredAll ? <Button size="small" color='primary' onClick={() => this.showAllSecuredData(popupState)}>Show All</Button> : null
                                                                        :
                                                                        this.state.showUnsecuredAll ? <Button size="small" color='primary' onClick={() => this.showAllUnsecuredData(popupState)}>Show All</Button> : null}
                                                                </Box>
                                                                <Popover
                                                                    {...bindPopover(popupState)}
                                                                    anchorOrigin={{
                                                                        vertical: 'bottom',
                                                                        horizontal: 'right',
                                                                    }}
                                                                    transformOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'left',
                                                                    }}>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', m: 2 }}>
                                                                        <TextField
                                                                            variant='outlined'
                                                                            placeholder='Search'
                                                                            onChange={(event) => { this.state.projectType === 0 ? this.securedSearch(event.target.value) : this.unSecuredSearch(event.target.value) }}
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <InputAdornment position='end'>
                                                                                        {this.state.showUnsecuredAll ?
                                                                                            <IconButton
                                                                                                onClick={() => this.state.projectType === 0 ? this.showAllSecuredData(popupState) : this.showAllUnsecuredData(popupState)}
                                                                                            >
                                                                                                <CloseIcon fontSize="small" />
                                                                                            </IconButton> : null}
                                                                                    </InputAdornment>
                                                                                )
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                </Popover>
                                                            </Box>
                                                        )}
                                                    </PopupState>
                                                </Box>
                                            </Box>

                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box>
                                            <PopupState variant="popover" popupId="demo-popup-popover" >
                                                {(popupState) => (
                                                    <Box sx={{ marginTop: '15px', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', p: 0.5 }}>
                                                        <div style={{ fontSize: this.screenSizeCheck() ? 'medium' : 'small', color: getSecondaryColor() }}  >
                                                            COMPLETED
                                                        </div>
                                                        <Box>
                                                            <Box >
                                                                <Tooltip title="Search Completed Projects">
                                                                    <SearchIcon {...bindTrigger(popupState)}
                                                                        fontSize="small" color="secondary" style={{ cursor: 'pointer', marginLeft: "3px", mt: 0.5 }} />
                                                                </Tooltip>
                                                                {this.state.showCompletedAll ?
                                                                    <Button size="small" color='primary' onClick={() => this.showAllCompletedData(popupState)}>Show All</Button> : null}
                                                            </Box>
                                                            <Popover
                                                                {...bindPopover(popupState)}
                                                                anchorOrigin={{
                                                                    vertical: 'bottom',
                                                                    horizontal: 'right',
                                                                }}
                                                                transformOrigin={{
                                                                    vertical: 'top',
                                                                    horizontal: 'left',
                                                                }}>
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', m: 2 }}>
                                                                    <TextField
                                                                        variant='outlined'
                                                                        placeholder='Search'
                                                                        disabled={this.state.isLoading}
                                                                        onChange={(event) => this.completedSearch(event.target.value)}
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position='end'>
                                                                                    {this.state.showCompletedAll ?
                                                                                        <IconButton
                                                                                            onClick={() => this.showAllCompletedData(popupState)}
                                                                                        >
                                                                                            <CloseIcon fontSize="small" />
                                                                                        </IconButton> : null}
                                                                                </InputAdornment>
                                                                            )
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Popover>
                                                        </Box>
                                                    </Box>
                                                )}
                                            </PopupState>
                                        </Box>
                                    </Grid>
                                </Grid>
                            }
                        </Box>
                    </Paper>
                    <div ref={(projectElement) => { this.projectElement = projectElement }}   >
                        <Box >
                            <Paper style={{ borderRadius: "0 0 10px 10px" }} >
                                <Divider style={{ backgroundColor: getSecondaryColor() }} />
                                <Box marginLeft={1} style={{ height: window.innerHeight - 150 }} >
                                    {this.state.isLoading ?
                                        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                            <CircularProgress color="secondary" />
                                        </Box> :
                                        this.screenSizeCheck() ?
                                            <Grid container spacing={2}>
                                                <Grid item xs={4}>
                                                    <ProjectList data={this.state.liveSecured} access={this.props.access} getData={this.handlegetData} disableShowAll={this.handleShowAll} />
                                                </Grid>
                                                <Grid item xs={4} >
                                                    <ProjectList data={this.state.liveUnsecured} access={this.props.access} getData={this.handlegetData} disableShowAll={this.handleShowAll} />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <CompletedProjectsList
                                                        ref={this.refSearch}
                                                        height={this.state.height !== 0 && this.state.height}
                                                        access={this.props.access}
                                                    />
                                                </Grid>
                                            </Grid> :
                                            <Grid container spacing={2}>
                                                {this.state.projectType === 0 ?
                                                    <Grid item xs={6}>
                                                        <ProjectList data={this.state.liveSecured} access={this.props.access} getData={this.handlegetData} disableShowAll={this.handleShowAll} />
                                                    </Grid> :
                                                    <Grid item xs={6} >
                                                        <ProjectList data={this.state.liveUnsecured} access={this.props.access} getData={this.handlegetData} disableShowAll={this.handleShowAll} />
                                                    </Grid>}
                                                <Grid item xs={6}>
                                                    <CompletedProjectsList
                                                        ref={this.refSearch}
                                                        height={this.state.height !== 0 && this.state.height}
                                                        access={this.props.access}
                                                    />
                                                </Grid>
                                            </Grid>
                                    }
                                </Box>
                            </Paper>

                        </Box>
                    </div>
                </Box>

                <Dialog fullScreen open={this.state.open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <Box display={'flex'} flexDirection={'row'} width={'100%'}>
                                <Box display={'flex'} flexDirection={'row'} flexGrow={1} alignItems={'center'}>
                                    <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography variant="h6">
                                        {this.state.tab === 0 ? "Secured" : "Unsecured"}
                                    </Typography>
                                </Box>
                            </Box>
                            <ThemeProvider theme={darkTheme}>
                                <ToggleButtonGroup
                                    size="small"
                                    value={this.state.unallocatedToggleView}
                                    onChange={handleUnallocatedToggle}
                                    exclusive
                                    aria-label="text formatting"
                                    style={{ color: 'inherit' }}
                                >
                                    <ToggleButton value={0}>
                                        Live
                                    </ToggleButton>
                                    <ToggleButton value={1}>
                                        Archive
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </ThemeProvider>
                            <IconButton color='inherit' onClick={() => this.excelExport()}>
                                <GetAppIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Box marginTop={8}>
                        {this.state.tab === 0 ?
                            <Secured ref={this.toggleButtonGroup} access={this.props.access} tabValue={this.state.liveOrCompleted} disableTab={true} /> :
                            <UnsecuredProjects ref={this.toggleButtonGroup} access={this.props.access} tabValue={this.state.liveOrCompleted} disableTab={true} />
                        }
                    </Box>
                </Dialog>
            </div >

        )
    }
}

export default withSnackbar(Projects);
